import { useSurveyForm, useUnitsForm } from "../helpers/useSurveyForm";
import { SiteSurveyConfiguration } from "api/types/siteSurveyConfiguration";
import { Attribute } from "../helpers/Attribute";
import { Photo } from "api/types/photo";

interface AttributesType {
  config: SiteSurveyConfiguration;
  unitIndex: number;
}
export function Attributes({ config, unitIndex }: AttributesType) {
  const { survey } = useSurveyForm();
  const { onAttributeValueChange, onPhotoChange, onDeletePhoto } =
    useUnitsForm();
  const currentUnit = survey.units[unitIndex];

  return (
    <>
      {config.unitConfiguration.attributes.map((attributeConfig, index) => {
        const matchingAttribute = currentUnit.attributes.find(
          (att) => att.attributeId === attributeConfig.id
        );

        function onAttributeValueChangeTmp(attributeValueText: string) {
          onAttributeValueChange(
            currentUnit,
            attributeConfig,
            attributeValueText
          );
        }

        function onPhotoChangeTmp(photo: Photo) {
          onPhotoChange(currentUnit, photo, attributeConfig);
        }

        function onDeletePhotoTmp() {
          onDeletePhoto(currentUnit, attributeConfig);
        }

        return (
          <Attribute
            key={`attribute-${attributeConfig.id}-${index}`}
            attributeConfig={attributeConfig}
            attributeValue={matchingAttribute}
            onAttributeValueChange={onAttributeValueChangeTmp}
            onPhotoChange={onPhotoChangeTmp}
            onDeletePhoto={onDeletePhotoTmp}
          />
        );
      })}
    </>
  );
}
